import { FormState } from 'react-formstate';
import React from 'react';
import { findDOMNode } from 'react-dom';
import invariant from 'invariant';

export const populateFormErrors = (formState: FormState, serverErrors: Object) => {
  const fields = formState.fields.map(field => field.name);

  const errors = fields.reduce((errors, name) => {
    const fieldState = formState.getFieldState(name);

    if (fieldState.isMessageVisibleOn('blur')
      && fieldState.getValidity() === 2
      && fieldState.isSubmitted()
    ) {
      return {
        ...errors,
        [name]: fieldState.getMessage()
      };
    }

    return errors;
  }, {});

  const withServerErrors = { ...errors, ...serverErrors };
  return withServerErrors;
};

export const focusOnInput = (parentComponent, inputName) => {
  // eslint-disable-next-line react/no-find-dom-node
  const inputNode = findDOMNode(parentComponent).querySelector(`[name="${inputName}"]`);

  invariant(inputNode, 'cannot find form field to focus');

  try {
    inputNode.focus();
    inputNode.selectionEnd = inputNode.value.length;
    inputNode.selectionStart = inputNode.selectionEnd;
  } catch (e) {

  }
};

export const focusOnFirstInvalid = (formState: FormState, parentComponent: React.Component) => {
  const field = formState.fields.find(({ name }) =>
    formState.getFieldState(name).isInvalid()
  );

  if (field) {
    focusOnInput(parentComponent, field.name);
  }
};

export const onlyChangedModel = (formState: FormState, model: Object) => {
  const fields = Object.keys(model);

  const changedModel = fields.reduce((acc, field) => {
    const fieldState = formState.getFieldState(field);
    const isChanged = fieldState.getInitialValue() !== model[field];

    return isChanged ? { ...acc, [field]: model[field] } : acc;
  }, {});

  return changedModel;
};



// WEBPACK FOOTER //
// ./app/Assets/js/utils/validation.js